import React from 'react';
import frusLogoOval from '../assets/images/new-frus-logo-no-bg.png';

const HeartbeatLoadingLogo = () => {
  return <img className="splashscreen" src={frusLogoOval} alt="splash screen" />;
};

export default HeartbeatLoadingLogo;
